<div class="row">
    <div class="col-md-12">
      <!-- <filter-with-org-jed
      (RefreshStatusClicked)="refreshStatus($event)"
      (FilterApplied)="applayFilter($event)"
      #filterFak
      ></filter-with-org-jed> -->
      <yt-fw-default-list-modal [CondensedTable]="true" #defaultList></yt-fw-default-list-modal>
    </div>
  </div>